/**
 * ngrok's free tier serves a consent interstitial to anything that looks like a
 * browser. It comes back as HTTP 200 with `content-type: text/html`, an
 * `ngrok-error-code: ERR_NGROK_6024` header — and, critically, **no CORS
 * headers**. So a browser reports it as
 *
 *   "blocked by CORS policy: No 'Access-Control-Allow-Origin' header"
 *
 * rather than as an ngrok problem, and the network tab shows the confusing
 * `net::ERR_FAILED 200 (OK)`. The API's own CORS config is fine; the response
 * never reaches it.
 *
 * The documented bypass is the header below. It is a custom header, so it makes
 * requests non-simple and triggers a CORS preflight — the API allows it, and
 * echoes it back in `access-control-allow-headers`. ngrok does not interstitial
 * the OPTIONS preflight itself, so the round trip works.
 *
 * Only used when the API base URL is actually an ngrok host, so nothing extra is
 * ever sent to production.
 */
export const NGROK_BYPASS_HEADER = "ngrok-skip-browser-warning";

export function isNgrokHost(url: string): boolean {
  try {
    return /\.ngrok(-free)?\.(dev|app|io)$/.test(new URL(url).hostname);
  } catch {
    return false;
  }
}
